import styled from 'styled-components';
import { palette } from 'styled-theme';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: left;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
`;

export const DropdownButton = styled.button`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  background-color: transparent;
  color: white;
  border: none;
  border-bottom: 1px solid #e6b471;
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: transparent;
  }

  &:focus {
    outline: none;
    border-bottom: 1px solid #e6b471;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  right: 0;
  z-index: 10;
  width: 224px;
  padding-bottom: 8px;
  margin-top: 8px;
  background: ${palette('background', 0)};
  border: 1px solid ${palette('border', 1)};
  border-radius: 2px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const DropdownMenuInner = styled.div`
  padding: 4px 0;
  max-height: 192px;
  overflow-y: auto;

  /* Hide scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DropdownItem = styled.button`
  display: block;
  width: 100%;
  padding: 8px 16px;
  font-size: 14px;
  text-align: left;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1f2347;
  }

  &:focus {
    outline: none;
    background-color: #1f2347;
  }
`;

export const SelectedItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const SelectedItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e6b471;
  color: #171a3b;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 14px;
`;

export const RemoveButton = styled.button`
  color: #171a3b;
  background: none;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: #dc2626;
  }

  &:focus {
    outline: none;
    color: #dc2626;
  }
`;

export const ChevronIcon = styled.svg`
  width: 20px;
  height: 20px;
  margin-left: 8px;
  margin-right: -4px;
  transition: transform 0.2s;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
